import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './pdf-viewer.styles';

const PDFViewer = ({ sourceUrl }) => {

    return (
        <Container>
            <div className="App">
                <iframe width="70%" height="100vh" className='iframe' src={ sourceUrl } allowfullscreen></iframe>
            </div>
        </Container>
    );
};

PDFViewer.propTypes = {
    sourceUrl: PropTypes.string,
};

export default PDFViewer;

